import { render, staticRenderFns } from "./FilterTags.vue?vue&type=template&id=6c4679c4&scoped=true&"
import script from "./FilterTags.vue?vue&type=script&lang=ts&"
export * from "./FilterTags.vue?vue&type=script&lang=ts&"
import style0 from "./FilterTags.vue?vue&type=style&index=0&id=6c4679c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4679c4",
  null
  
)

export default component.exports